<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" type="text" label="Наименование позиции"
        v-model.trim="unit.name" placeholder="Введите наименование" />
      <ccs-input class="ccs-6" type="textarea" label="Описание"
        v-model.trim="unit.description" placeholder="Введите описнаие" />
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить и добавить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Unit',
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      unit: {
        name: '',
        description: '',
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => undefined,
    },
    isPackageCreation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('packages', ['createUnit', 'updateUnit']),
    async submit() {
      if (this.$props.isPackageCreation) {
        this.$emit('submit', this.unit);
        this.$emit('close');
        return;
      }
      if (this.unit.id) {
        await this.editUnit();
      } else {
        await this.addUnit();
      }
    },
    async addUnit() {
      try {
        await this.createUnit(this.unit);
        this.$toasted.success('Позиция добавлена');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async editUnit() {
      try {
        await this.updateUnit(this.unit);
        this.$toasted.success('Позиция изменена');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.unit = this.$props.data;
    }
  },
}
</script>

<style lang="scss" scoped>

</style>